import { useAuth } from '@/lib'
import type { RoleEnumKey } from '@jobilla/nexus-sdk'
import type { ReactNode } from 'react'

export interface RequireAccessProps {
	permission?: string
	role?: RoleEnumKey | RoleEnumKey[]
	fallback?: ReactNode
	children: ReactNode
}

export function RequireAccess({ permission, role, fallback = null, children }: RequireAccessProps) {
	const { isLoading, user, role: userRole, permissions } = useAuth()

	if (isLoading || !user) {
		return null
	}

	if (role) {
		const roles = Array.isArray(role) ? role : [role]
		if (!userRole || !roles.includes(userRole)) {
			return <>{fallback}</>
		}
	}

	if (permission) {
		if (!permissions?.includes(permission)) {
			return <>{fallback}</>
		}
	}

	return <>{children}</>
}
